<!-- Header -->
<div class="card-header card-header-grid">
  <!-- Search -->
  <div class="input-group input-lined" role="search">
    <div class="input-group-text">
      <i role="img" class="fa fa-search text-muted" aria-hidden="true"></i>
    </div>
    <input
      class="form-control"
      type="search"
      placeholder="{{ 'general.search' | translate }}"
      attr.aria-label="{{ 'general.search' | translate }}"
      [(ngModel)]="filterTerm"
      (ngModelChange)="onSearch($event)"
    />
  </div>
  <!-- End Search -->

  <div class="d-flex justify-content-end align-items-center">
    <div>
      <span>
        {{ (tableData | recursiveFilter: filterTerm)?.length }}
        {{ 'general.total' | translate }}
      </span>
    </div>

    <div class="btn-group ms-3" dropdown *ngIf="bulkActions?.length">
      <button
        class="btn btn-sm btn-white dropdown-toggle"
        type="button"
        aria-controls="bulkAction5"
        dropdownToggle
      >
        {{ 'general.bulkActions' | translate }}
      </button>

      <ul
        *dropdownMenu
        class="dropdown-menu dropdown-menu-right"
        role="menu"
        id="bulkAction5"
      >
        <li *ngFor="let bulkAction of bulkActions">
          <a
            class="dropdown-item"
            href="javascript:;"
            (click)="onClickBulkAction(bulkAction)"
          >
            {{ 'general.' + bulkAction | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- End Row -->
</div>
<!-- End Header -->

<!-- Table -->
<div class="table-responsive">
  <table
    class="table table-borderless table-striped table-nowrap"
    [mfData]="tableData | recursiveFilter: filterTerm"
    #dataTable="mfDataTable"
    [mfRowsOnPage]="25"
  >
    <thead class="table-light">
      <tr>
        <th
          scope="col"
          (click)="onToggleAllChecked()"
          class="cursor-pointer"
          style="max-width: 60px"
        >
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="allCheckedToggle"
            attr.aria-label="{{ 'general.selectAll' | translate }}"
          />
        </th>
        <th scope="col" style="width: 40%">
          <mfDefaultSorter by="description">
            {{ 'general.description' | translate }}
          </mfDefaultSorter>
        </th>
        <th scope="col" style="width: 40%">
          <mfDefaultSorter by="tags">
            {{ 'tagModule.tags' | translate }}
          </mfDefaultSorter>
        </th>
        <th scope="col">
          <span
            class="flag flag-nl"
            role="img"
            attr.aria-label="{{ 'wcag.nl' | translate }}"
          ></span>
        </th>
        <th scope="col">
          {{ 'translationModule.translations' | translate }}
        </th>
        <th scope="col">
          <span
            class="flag flag-en"
            role="img"
            attr.aria-label="{{ 'wcag.en' | translate }}"
          ></span>
        </th>
        <th scope="col" style="width: 20%">
          <mfDefaultSorter by="price">
            {{ 'general.price' | translate }}
          </mfDefaultSorter>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let item of dataTable.data; let i = index"
        class="cursor-pointer"
      >
        <td
          (click)="onCheckRow(item)"
          class="cursor-pointer"
          style="max-width: 60px"
        >
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="this.checkedIds.get(item.id)"
            attr.aria-label="{{ 'wcag.selectThis' | translate }}"
          />
        </td>
        <td
          (click)="onRowClicked(item)"
          (keyup.enter)="onRowClicked(item)"
          tabindex="0"
          role="link"
          >{{ item.description }}</td
        >
        <td (click)="onRowClicked(item)">
          <div *ngFor="let chunk of getTags(item) | async | chunk: 3">
            <span *ngFor="let tag of chunk" class="badge bg-soft-secondary">
              <span *ngIf="tag">
                {{ tag['description_' + (selectedLanguage$ | async)] }}
              </span>
            </span>
          </div>
        </td>
        <td class="text-center">
          <i
            *ngIf="hasTranslation(item, 'nl') | async"
            attr.aria-label="{{ 'wcag.hasTranslation' | translate }}"
            class="fas fa-check text-success"
            role="img"
          ></i>
          <i
            *ngIf="!(hasTranslation(item, 'nl') | async)"
            attr.aria-label="{{ 'wcag.missingTranslation' | translate }}"
            class="fas fa-times text-danger"
            role="img"
          ></i>
        </td>
        <td></td>
        <td class="text-center">
          <i
            *ngIf="hasTranslation(item, 'en') | async"
            attr.aria-label="{{ 'wcag.hasTranslation' | translate }}"
            class="fas fa-check text-success"
            role="img"
          ></i>
          <i
            *ngIf="!(hasTranslation(item, 'en') | async)"
            attr.aria-label="{{ 'wcag.missingTranslation' | translate }}"
            class="fas fa-times text-danger"
            role="img"
          ></i>
        </td>
        <td (click)="onRowClicked(item)">{{ item.price | currency }}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="6" class="pb-0">
          <mfBootstrapPaginator
            [rowsOnPageSet]="[25, 50, 100]"
          ></mfBootstrapPaginator>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
